import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { contactInfo } from "../mock/data";

const footerLinks = [
  {
    title: "Company",
    items: [
      { label: "About", to: "/about" },
      { label: "What We Do", to: "/services" },
      { label: "Our Work", to: "/work" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Ventures",
    items: [
      { label: "Party Kahan Hai", to: "/party-kahan-hai" },
      { label: "Home2Plate", to: "/home2plate" },
      { label: "DOOH School Network", to: "/services" },
      { label: "InsurAds", to: "/services" },
    ],
  },
];

const Footer = () => {
  return (
    <footer style={{ background: "var(--oo-bg-2)", borderTop: "1px solid var(--oo-border)" }}>
      <div className="oo-container" style={{ paddingTop: 72, paddingBottom: 40 }}>
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <Logo />
            <p className="mt-6 max-w-xs" style={{ color: "var(--oo-muted)", lineHeight: 1.7, fontSize: 15 }}>
              An integrated out-of-home media and infrastructure company — building media that moves cities.
            </p>
            <Link to="/contact" className="btn-ghost mt-7" style={{ padding: "12px 22px", fontSize: 14 }}>
              Start a Conversation <ArrowUpRight size={16} />
            </Link>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="oo-eyebrow" style={{ marginBottom: 20 }}>{col.title}</h4>
              <ul className="space-y-3">
                {col.items.map((it) => (
                  <li key={it.label}>
                    <Link
                      to={it.to}
                      className="hover-underline text-sm"
                      style={{ color: "var(--oo-muted)", transition: "color 0.2s" }}
                    >
                      {it.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="oo-eyebrow" style={{ marginBottom: 20 }}>Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3" style={{ color: "var(--oo-muted)", fontSize: 14 }}>
                <Phone size={16} className="text-accent" /> {contactInfo.phone}
              </li>
              <li className="flex items-center gap-3" style={{ color: "var(--oo-muted)", fontSize: 14 }}>
                <Mail size={16} className="text-accent" /> {contactInfo.email}
              </li>
              <li className="flex items-center gap-3" style={{ color: "var(--oo-muted)", fontSize: 14 }}>
                <MapPin size={16} className="text-accent" /> {contactInfo.hq}
              </li>
            </ul>
          </div>
        </div>

        <div
          className="flex flex-col md:flex-row items-center justify-between gap-4"
          style={{ marginTop: 56, paddingTop: 28, borderTop: "1px solid var(--oo-border)" }}
        >
          <p style={{ color: "var(--oo-faint)", fontSize: 13 }}>
            © {new Date().getFullYear()} OOHMA Multimedia. All rights reserved.
          </p>
          <p style={{ color: "var(--oo-faint)", fontSize: 13 }}>Est. November 2019 · Dwarka, New Delhi</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
